export default "__VITE_ASSET__CxM78FbT__"